import { render, staticRenderFns } from "./CustomerAccount.vue?vue&type=template&id=759f7a55&scoped=true"
import script from "./CustomerAccount.vue?vue&type=script&lang=ts"
export * from "./CustomerAccount.vue?vue&type=script&lang=ts"
import style0 from "./CustomerAccount.vue?vue&type=style&index=0&id=759f7a55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759f7a55",
  null
  
)

export default component.exports